export const RATE_PACKAGE_BULK_UPSERT_FIELDS: { key: string; label: string }[] = [
  { key: 'rateAgreementCode', label: 'Rate Agreement Code' },
  { key: 'rentalCategoryCode', label: 'Rental Category Code' },
  { key: 'trialPeriod', label: 'Trial Period' },
  { key: 'paymentInitial', label: 'Payment Initial' },
  { key: 'paymentRecurring', label: 'Payment Recurring' },
  { key: 'ldwInitial', label: 'LDW Initial' },
  { key: 'ldwRecurring', label: 'LDW Recurring' },
  { key: 'minFinalPayPct', label: 'Min Final Pay PCT' },
  { key: 'payInitialIncludesTax', label: 'Pay Initial Includes Tax' },
  { key: 'ldwInitialIncludesTax', label: 'LDW Initial Includes Tax' }
];
